<div class="pcs-container">
  <div class="pcs-header">
    <h3 class="pcs-title">Organization Structure</h3>
    @if ((isAdmin || isSystemUser) && !parentOrganization) {
    <div class="card-actions">
      @if (!isEditingStructure) {
      <button mat-flat-button color="primary" type="button" (click)="toggleEditStructure()">
        Edit
      </button>
      }
    </div>
    }
  </div>

  <div class="pro-card column">
    @if (!isEditingStructure) {
    <div class="org-chart-container">
      @if (!parentOrganization && childOrganizations.length > 0) {
      <div class="org-chart-row">
        <div class="org-box current-org">
          {{ organization?.name }}
        </div>
      </div>
      <div class="flowchart-t-junction" #tJunction>
        <div class="flowchart-line-vertical"></div>
        <div class="flowchart-line-horizontal" [style.left]="horizontalLineStyle.left"
          [style.width]="horizontalLineStyle.width"></div>
      </div>
      <div class="org-level-children" #childrenContainer>
        @for (child of childOrganizations; track child.id; let i = $index) {
        <div class="org-child-wrapper">
          <div class="flowchart-line-to-child" [class.hide-connector]="boxesToHideConnectors.has(i)"></div>
          <div class="org-box">
            {{ child.name }}
          </div>
        </div>
        }
      </div>
      }
      @if (parentOrganization) {
      <div class="org-chart-row">
        <div class="org-box">
          {{ parentOrganization.name }}
        </div>
      </div>
      @if (childOrganizations.length > 0) {
      <div class="flowchart-t-junction" #tJunction>
        <div class="flowchart-line-vertical"></div>
        <div class="flowchart-line-horizontal" [style.left]="horizontalLineStyle.left"
          [style.width]="horizontalLineStyle.width"></div>
      </div>
      <div class="org-level-children" #childrenContainer>
        @for (child of childOrganizations; track child.id; let i = $index) {
        <div class="org-child-wrapper">
          <div class="flowchart-line-to-child" [class.hide-connector]="boxesToHideConnectors.has(i)"></div>
          <div class="org-box" [class.current-org]="child.id === currentOrgId">
            {{ child.name }}
          </div>
        </div>
        }
      </div>
      }
      }
      @if (!parentOrganization && childOrganizations.length === 0) {
      <div class="empty-state">
        <p class="text-muted">No organizational relationships</p>
      </div>
      }
    </div>
    }
    @if (isEditingStructure) {
    <form [formGroup]="structureForm">
    <div class="custom-form-field">
    <label>Select Child Organizations:</label>
    <app-mat-multi-select-pagination
      [requiredMessage]="'Please select child organizations'"
      [options]="allProviderOrganizations"
      [control]="structureForm.controls['childOrgIds']"
      [innerLabel]="'Select organizations'"
      [hasNextPage]="hasNextPageOrganizations"
      (loadMore)="onLoadMoreOrganizations($event)"
    />
  </div>

  <div class="form-actions" style="display: flex; gap: 12px; margin-top: 16px;">
    <button mat-stroked-button type="button" (click)="cancelEditStructure()">
      Cancel
    </button>
    <button mat-flat-button color="primary" type="button" (click)="saveStructureChanges()"
      [disabled]="isLoading">
      Save Changes
    </button>
  </div>
</form>
}
  </div>
</div>